<script>import { derivedKeys } from "./derivedKeys.js";
const values = derivedKeys($$restProps);
</script>

<slot {...$values} />
